var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"speech-bubble answer",class:_vm.element.animation,staticStyle:{"position":"relative"},attrs:{"id":'answer' + _vm.getId()},on:{"click":_vm.clicked}},[_vm._v("\n  "+_vm._s(_vm.element.text)+"\n  "),(_vm.removable == true)?_c('span',{staticStyle:{"position":"absolute","right":"-25px","cursor":"pointer","color":"black"},on:{"click":_vm.remove}},[_vm._v("x")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-732b98ea","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/onboarding/onboarding-answer.vue
// module id = 1927
// module chunks = 0